import Image from 'next/image';
import { useEffect, useState } from 'react';

import { ErrorOutline } from '@styled-icons/material';

import IconPopup from '../../../../components/IconPopup';
import { useTPlateEditorRef } from '../../../../plate';

export function ImageNotionAlertPopupOverlayToolbar() {
  const [open, setopen] = useState(false);

  const editor = useTPlateEditorRef();

  useEffect(() => {
    editor.emitter.on('popup:toggle-image-notion-alert', () => {
      setopen((curr) => !curr);
    });

    return () => {
      editor.emitter.off('popup:toggle-image-notion-alert');
    };
  }, []);

  return (
    <IconPopup
      width={490}
      height={567}
      title="This image will expire in 1 hour"
      Icon={ErrorOutline}
      open={open}
      setopen={setopen}
      error
    >
      <div style={{
        display: 'grid',
        gap: 32,
        textAlign: 'center',
        marginTop: 10,
        justifyItems: 'center',
        fontWeight: 500,
      }}
      >
        <p style={{
          color: 'var(--neutral-600)',
          letterSpacing: '-0.01em',
        }}
        >
          This image uses a Notion URL, which means the image link will expire in 1 hour.
        </p>
        <Image
          src="/images/image-source-screenshot.png"
          alt="image source screenshot"
          width={397}
          height={121}
        />
        <p style={{
          color: 'var(--neutral-800)',
          letterSpacing: '-0.01em',
        }}
        >
          <b>Re-upload the image on Typedream</b>
          {' '}
          by clicking
          {' '}
          <b>Replace Image</b>
          {' '}
          on the right toolbar to prevent the image from disappearing.
          {' '}
        </p>
      </div>
    </IconPopup>
  );
}

export default ImageNotionAlertPopupOverlayToolbar;
